import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PrintDetails from 'src/components/design-system/PrintDetails';
import useVarianceDetails from 'src/hooks/useVarianceDetails';
import usePoDetailsApi from 'src/services/usePoDetailsApi';
import usePoHistoryApi from 'src/services/usePoHistoryApi';
import PDF from './PDF';

const PrintVarianceDetails = () => {
  const { varianceId, variances, isMultiplePeriodAssigned } = useVarianceDetails();
  const [searchParams] = useSearchParams();
  const poId = searchParams.get('poid') || searchParams.get('poId') || '';
  const { poHistory } = usePoHistoryApi(poId);
  const { poDetails } = usePoDetailsApi(poId);
  const title = 'Variance';
  const [state, setState] = useState({
    history: false,
    notes: false,
    attachments: false,
  });

  const pdf = useMemo(
    () => (
      <PDF
        isHistoryIncluded={state.history}
        isNotesIncluded={state.notes}
        variances={variances}
        varianceId={varianceId}
        poHistory={poHistory}
        title={title}
        isMultiplePeriodAssigned={isMultiplePeriodAssigned}
        poDetails={poDetails}
      />
    ),
    [
      isMultiplePeriodAssigned,
      poDetails,
      poHistory,
      state.history,
      state.notes,
      varianceId,
      variances,
    ]
  );

  return (
    <PrintDetails
      pdf={pdf}
      setState={setState}
      state={state}
      documentNumber={varianceId}
      title={title}
      showAttachment={false}
    />
  );
};

export default PrintVarianceDetails;
